import {DataObjectId, Hub, HubData, JSONLikeValue} from 'yougile-model'
import {Task} from '@extensions/task'

/**
 * Expresses placement of the task with stickers. DataObjectId – is
 * the id of the column if task is rendered inside column
 */
export type StickerContainerKey =
  | DataObjectId
  | 'chat'
  | 'stats'
  | 'api'
  | 'repeat'

export interface StickerItemData {
  values?: string
  openMenu?: boolean
  currentValue?: any
  onPin?: (value: any) => void
  onUnpin?: () => void
  showAllUsers?: boolean
  containerKey: StickerContainerKey
  withMark?: boolean
}

export interface StickerHub {
  id: DataObjectId
  data?: HubData
  location: DataObjectId
  companyId: DataObjectId
  stickers: {[id: string]: JSONLikeValue}
  isCompleted?: boolean
}

export const isStickerHubCompleted = (task: StickerHub | undefined) => {
  return (
    task?.isCompleted || (task instanceof Hub && Task.getCompletionTime(task))
  )
}
